import { render } from "./walletHubConnected.vue?vue&type=template&id=7bf4b6a8&scoped=true&lang=pug"
import script from "./walletHubConnected.vue?vue&type=script&setup=true&lang=js"
export * from "./walletHubConnected.vue?vue&type=script&setup=true&lang=js"

import "./walletHubConnected.vue?vue&type=style&index=0&id=7bf4b6a8&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf4b6a8"]])

export default __exports__